module.exports = __webpack_public_path__ + "img/02.04be104c.jpg";